export function forwardDifference(f: (x: number) => number, a: number, h: number): number {
  return (f(a + h) - f(a)) / h;
}

export function symmetricDifference(f: (x: number) => number, a: number, h: number): number {
  return (f(a + h) - f(a - h)) / (2 * h);
}
